module.exports = __webpack_public_path__ + "img/iphone.b9c9b955.png";